/* Simulates Sitecore data, when using EikaView.tsx to simulate Sitecore environment locally. */
const sitecoreSimulationData = {
    // Config String Paths
    calculatorPath: '/lane/salgspant',
    landingPagePath: '/min-oversikt/soknadsoversikt',
    applicationPath: '/min-oversikt/salgspantsoknad',
    completionPathSecuredLoan: '/min-oversikt/salgspantfullfor',
    completionPathCreditLoan: '/min-oversikt/smalansoknad',
    completionPathCreditLoanAdvisor: '/min-oversikt/smalansoknad',
    completionPathCreditCard: '/min-oversikt/kredittkortsoknad',

    // Sitecore text/form keys
    text: {
        /* Loading */
        loadingDefault: 'Laster...',
        loadingProducts: 'Henter produkter...',
        loadingApplication: 'Henter lånedetaljer...',
        loadingOngoingApplications: 'Henter pågående søknader...',
        loadingApplicationStatus: 'Henter pågående søknad...',
        loadingUser: 'Sjekker kundeforhold...',
        loadingKyc: 'Henter tilleggsinformasjon...',
        loadingConsent: 'Henter samtykke...',
        loadingSigning: 'Forbereder dokumentet...',
        loadingSendApplication: 'Behandler søknad...',

        /* Landing Page */
        landingPageTitle: 'Pågående søknader',
        landingPageNoOngoingApplications: 'Du har for tiden ingen pågående søknader!',
        landingPageButton: 'Fullfør søknad',
        landingPageLoanCommitmentButton: 'Se lånebevis',
        landingPageLoanUpgradeButton: 'Jeg har funnet kjøretøyet',
        landingPageCaseStatus: 'Status',
        landingPageCaseNumber: 'Saksnummer',
        landingPageRegNo: 'Reg.nr',
        landingPageLoanAmount: 'Lånebeløp',
        landingPageLoanAmountCreditCard: 'Kredittgrense',
        landingPageStatusTextControl: 'Søknaden din er til behandling, du hører fra oss i løpet av de nærmeste dagene.',
        landingPageStatusTextDocumentsSent:
            'Søknaden din er innvilget. Vi venter på din signatur før fullføring av søknaden.',
        landingPageStatusTextDocumentsReceived:
            'Vi har mottatt signerte lånedokumenter - søknaden fullføres i løpet av kort tid.',
        landingPageNewCase: 'Du har en søknad under utfylling og vi trenger litt mer informasjon fra deg.',

        /* Vehicle Type Selector */
        vehicleTypeSelectorMainTitle: 'Billån og andre kjøretøy',
        vehicleTypeSelectorTitle: 'Vi tilbyr lån til bil og mange andre typer kjøretøy. Velg type kjøretøy:',
        vehicleTypeSelectorChooseVehicle: 'Velg kjøretøy',
        vehicleTypeSelectorDescriptionCar:
            'For alle personbiler. Bilen kan ikke være mer enn 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        vehicleTypeSelectorDescriptionCarElectric:
            'For alle personbiler med nullutslipp. Bilen kan ikke være mer enn 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        vehicleTypeSelectorDescriptionCarNoInsurance: 'For alle personbiler uansett alder og forsikring.',
        vehicleTypeSelectorDescriptionMC: 'For alle motorsykler.',
        vehicleTypeSelectorDescriptionATV: 'For alle ATV-er. Uansett om den er registrert som ATV, Traktor eller MC.',
        vehicleTypeSelectorDescriptionSnowmobile: 'For alle snøscootere.',
        vehicleTypeSelectorDescriptionCampingCar: 'For alle bobiler.',
        vehicleTypeSelectorDescriptionCampingCaravan: 'For alle tilhengere og trekkvogner.',
        vehicleTypeSelectorDescriptionBoat: 'For alle fritidsbåter. Skiller mellom +/- 7 meter.',

        /* Calculator */
        calculatorTitle: 'Sjekk pris og søk om lån eller lånebevis',
        calculatorInvalidProductUrl: 'Ingen gyldige kjøretøy valgt!',
        calculatorSubmitButtonLoan: 'Søk om lån',
        calculatorSubmitButtonLoanCommitment: 'Søk om lånebevis',

        /* Calculator: Loan Type Selection */
        calculatorLoanTypeSelectionLabel: 'Hva trenger du?',
        calculatorLoanTypeSelectionButtonLoan: 'Lån',
        calculatorLoanTypeSelectionButtonLoanCommitment: 'Lånebevis',
        calculatorLoanTypeSelectionInfoBoxLoanCommitmentCar:
            'Søk om lånebevis i dag så er finansieringen i orden når du vet hvilken bil du skal kjøpe.',
        calculatorLoanTypeSelectionInfoBoxLoanCommitmentOther:
            'Søk om lånebevis i dag så er finansieringen i orden når du vet hvilket kjøretøy du skal kjøpe.',

        /* Calculator: Vehicle Info */
        calculatorVehicleInfoLabelRegNo: 'Registreringsnummer',
        calculatorVehicleInfoLabelOdometerValue: 'Kilometerstand',
        calculatorVehicleInfoButton: 'Hent kjøretøy',
        calculatorVehicleInfoErrorObjectAge: 'Kjøretøyet er for gammelt. Maks alder er 14 år når lånet er nedbetalt.',
        calculatorVehicleInfoErrorZeroEmission:
            'Bilen må være nullutslipp - elektrisitet eller hydrogen - for å kunne søke om elbillånet.',
        calculatorVehicleInfoErrorNoMatch:
            'Vi klarte ikke å finne kjøretøyet. Du kan søke om lånebevis så hjelper vi deg med kjøretøyet etterpå.',

        /* Calculator: Loan Info */
        calculatorLoanInfoLabelVehiclePrice: 'Kjøpesum',
        calculatorLoanInfoLabelEquity: 'Egenkapital',
        calculatorLoanInfoAmountTitle: 'Ditt lånebehov',
        calculatorLoanInfoAmountText:
            'Søk nå og få svar med en gang. Hvis søknaden går til manuell behandling får du endelig svar innen to arbeidsdager.',
        calculatorLoanInfoApplicationInfoLoanCommitment:
            'Når du sender inn søknaden vil du bli kredittsjekket. Hvis du ikke er logget inn må du identifisere deg med BankID.',
        calculatorLoanInfoRepaymentTitleLoanCommitment: 'Sjekk hva lånet vil koste',
        calculatorLoanInfoRepaymentLabel: 'Nedbetalingstid',

        /* Calculator: Equity Info */
        calculatorEquityInfoHelperText1: 'Andel egenkapital er',
        calculatorEquityInfoHelperText2A: 'Øker du til',
        calculatorEquityInfoHelperText2B: 'får du',
        calculatorEquityInfoHelperText2C: 'og lavere rente på lånet ditt.',
        calculatorEquityInfoHelperText3: 'Du får vår beste rente.',

        /* Calculator: Info Boxes */
        calculatorInfoBoxLoanLessThan4Car:
            'Vi anbefaler å betale ned lånet så fort som mulig og på den tiden du tenker å beholde bilen.',
        calculatorInfoBoxLoanLessThan4Other:
            'Kjøretøyet må være maks 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorInfoBoxLoanBetween4And14Car:
            'Vi anbefaler å betale ned lånet så fort som mulig og på den tiden du tenker å beholde bilen. For grønne/ordinære lån kan bilen ikke overstige 14 år når lånet er nedbetalt. For kaskofritt lån må lånebehovet være maks kr 100 000.',
        calculatorInfoBoxLoanMoreThan4Other:
            'Vi anbefaler å betale ned lånet så fort som mulig og på den tiden du tenker å beholde kjøretøyet. Kjøretøyets alder kan ikke overstige 14 år når lånet er nedbetalt.',
        calculatorInfoBoxLoanMoreThan14Car:
            'Vi anbefaler å betale ned lånet så fort som mulig og på den tiden du tenker å beholde bilen. Kun kaskofritt billån er tilgjengelig hvis bilen er minst 14 år gammel.',
        calculatorInfoBoxLoanCommitment:
            'Vi anbefaler å betale ned lånet så fort som mulig og på den tiden du tenker å beholde kjøretøyet.',

        /* Calculator: Loan Info Modal */
        calculatorLoanInfoMonthlyCost: 'Månedsbeløp inkl. gebyr',
        calculatorLoanInfoTotal: 'Totalpris',
        calculatorLoanInfoNominalInterestRate: 'Nominell rente',
        calculatorLoanInfoEffectiveInterestRate: 'Effektiv rente',
        calculatorLoanInfoEstablishmentFee: 'Etableringsgebyr',
        calculatorLoanInfoRegistrationFee: 'Tinglysningsgebyr',
        calculatorLoanInfoTermFee: 'Termingebyr',
        calculatorLoanInfoDisclaimer:
            'Verdiene her kan være litt unøyaktig. Endelige verdier er synlige ved innvilget lånesøknad.',
        calculatorLoanInfoDescriptionCar:
            'Bilen må være mindre enn 15 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionCarElectric:
            'Bilen må ha CO2-utslipp inntil 100 g/km og være mindre enn 15 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionCarNoInsurance:
            'Lånebehov maks kr 100 000. Nedbetalingstid maks 5 år. Ikke krav om kaskoforsikring.',
        calculatorLoanInfoDescriptionMC:
            'MC-en/motorsykkelen må være maks 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionATV:
            'ATV-en / firehjulingen må være maks 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionSnowmobile:
            'Snøscooteren må være maks 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionCampingCar:
            'Bobilen må være maks 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionCampingCaravan:
            'Campingvognen må være maks 14 år når lånet er nedbetalt. Krever kaskoforsikring.',
        calculatorLoanInfoDescriptionBoat: 'For alle fritidsbåter. Skiller mellom +/- 7 meter.',
        calculatorLoanInfoOpenModal: 'Vis alle detaljer',
        calculatorLoanInfoCloseModal: 'Lukk',

        /* Application */
        applicationTitleA: 'Søk om',
        applicationTitleB: '- trygt og enkelt!',
        applicationMissingCacheId: 'Vi mangler data fra lånekalkulator, gå til kalkulatorsiden for å velge ditt lån.',

        /* SBL */
        sblTitle: 'Vi trenger ditt samtykke',
        sblInfoText1:
            'Vi henter lønnsslipper for siste halvår og siste skattemelding fra Skatteetaten digitalt. Du slipper å finne frem dokumentasjon og sende det som vedlegg til søknaden - enklere for både deg og oss. For at vi skal kunne gjøre det må du samtykke til at vi kan hente disse opplysningene.',
        sblInfoText2:
            'Når du trykker på "Gi samtykke" under vil du bli sendt til altinn.no for å logge deg inn og samtykke. Samtykket blir gitt til Eika Digitalbank AS. Du kommer deretter tilbake hit og kan fortsette søknaden.',
        sblGoToAltinnButtonText: 'Gi samtykke',
        sblErrorHeader: 'Noe gikk galt med Altinn',
        sblErrorText: 'Vi kan ikke gå videre fordi samtykket med Altinn ble avslått eller det skjedde en intern feil.',
        sblErrorLinkText: 'Tilbake til forsiden',
        sblErrorLink: '/',
        sblErrorInfoBox: '{defaultInfoBoxText}',

        applicationNotFoundErrorTitle: 'Søknaden din ble ikke funnet',
        applicationNotFoundErrorText:
            'Vi klarte ikke å finne søknaden din. Vennligst sjekk at id i lenken er korrekt, eller ta kontakt med banken hvis du trenger hjelp.',
        applicationNotFoundErrorLinkText: 'Tilbake til forsiden',
        applicationNotFoundErrorLink: '/',
        applicationNotFoundErrorInfoBox: '{defaultInfoBoxText}',

        dsfDataNotFoundErrorTitle: 'Fant ikke kunden',
        dsfDataNotFoundErrorText: 'Vi klarte ikke å finne denne kunden i systemet.',
        dsfDataNotFoundErrorLinkText: 'Tilbake til forsiden',
        dsfDataNotFoundErrorLink: '/',
        dsfDataNotFoundErrorInfoBox: '{defaultInfoBoxText}',

        /* Application: Loan Info */
        applicationLoanInfoAboutVehicleTitle: 'Om kjøretøyet',
        applicationLoanInfoAboutLoanTitle: 'Om lånet',
        applicationLoanInfoRegNo: 'Registreringsnummer',
        applicationLoanInfoOdometerValue: 'Kilometerstand',
        applicationLoanInfoVehiclePrice: 'Kjøpesum',
        applicationLoanInfoEquity: 'Egenkapital',
        applicationLoanInfoLoanPeriod: 'Nedbetalingstid',
        applicationLoanInfoLoanAmount: 'Lånebehov',
        applicationLoanInfoComment:
            'Du er i ferd med å søke om et annuitetslån med flytende rente. Som sikkerhet for lånet så tar vi pant i kjøretøyet. Skulle vilkårene for lånet endre seg underveis, så vil du bli varslet i god tid før endringen trer i kraft. Les mer om produktet på våre nettsider.',

        /* Loan Application: Applicant Info Labels */
        applicantLabelHasCoApplicant: 'Har du medlåntaker?',
        applicantLabelConfirmCoApplicantAddress: 'Bekrefter at min medsøker og meg har samme bostedsadresse',
        applicantLabelSsn: 'Fødselsnummer',
        applicantLabelEmail: 'E-post',
        applicantLabelPhone: 'Mobil',
        applicantLabelLivingCondition: 'Boforhold',
        applicantLabelRentalFee: 'Leiekostnader',
        applicantLabelEmployment: 'Arbeidsforhold',
        applicantTitleTradeIn: 'Er det heftelse/restgjeld på bilen du ønsker å låne til?',
        applicantLabelTradeIn: 'Ja, det er gjeld som skal innfris og pant som skal heves med dette nye lånet',
        applicantLabelTradeInDebt: 'Hva er restgjelden på bilen hos annen bank/finansieringsselskap?',
        applicantMainGrossIncomeLabel: 'Din årsinntekt før skatt',
        applicantMainTotalDebtLabel: 'Din gjeld/lån til bolig, kjøretøy, studielån, kredittkort og forbrukslån',
        applicantMainTotalDebtSubLabel:
            'Fyll inn totalsummen av all gjeld/lån du har. Hvis du har medlåntaker, så bruker du bare din andel av lånene.',
        applicantCoGrossIncomeLabel: 'Medlåntakers årsinntekt før skatt',
        applicantCoTotalDebtLabel: 'Medlåntakers gjeld/lån til bolig, kjøretøy, studielån, kredittkort og forbrukslån',
        applicantCoTotalDebtSubLabel:
            'Fyll inn totalsummen av all gjeld/lån til medlåntaker. Bruk kun medlåntakers andel av lånene.',

        /* Application: Step 4 */
        applicationSubmitButton: 'Send inn søknaden',
        applicationSubmitInfoBox:
            'Når du søker om lån vil vi utføre en kredittsjekk og innhente opplysninger fra kredittopplysningsforetak og gjeldsregister.',
        applicationSubmitInfoBox2:
            'Ved å sende inn søknaden bekrefter jeg at de oppgitte opplysninger om min økonomiske situasjon er korrekte. Jeg er også kjent med at eventuelle uriktige eller tilbakeholdelse av opplysninger eller dokumentasjon fra min side kan resultere i at avtalen heves.',
        applicationSubmitInfoBoxCoApplicant:
            'Når du søker om lån vil vi utføre en kredittsjekk og innhente opplysninger fra kredittopplysningsforetak og gjeldsregister.',
        applicationSubmitInfoBoxCoApplicant2:
            'Ved å sende inn søknaden bekrefter jeg at de oppgitte opplysninger om min økonomiske situasjon er korrekte. Jeg er også kjent med at eventuelle uriktige eller tilbakeholdelse av opplysninger eller dokumentasjon fra min side kan resultere i at avtalen heves.',

        /* Completion */
        completionTitle: 'Fullfør søknad om',
        completionApplicationNotFound: 'Vi klarte ikke å finne en pågående søknad for dette saksnummeret.',
        completionApplicationMissingCaseId: 'Mangler et gyldig saksnummer.',

        /* Completion: Loan Details */
        completionDetailsIngressA: 'Din søknad om',
        completionDetailsIngressB: 'er innvilget og dette er vårt tilbud til deg:',
        completionDetailsIngressNewCase:
            'Du har startet en lånesøknad og vi trenger litt mer informasjon fra deg før vi kan fullføre søknaden.',
        completionDetailsLoanInfoTitle: 'Lånedetaljer',
        completionDetailsVehicleInfoTitle: 'Kjøretøy',
        completionDetailsCaseNo: 'Saksnummer',
        completionDetailsEffectiveInterest: 'Effektiv rente',
        completionDetailsNominalInterest: 'Nominell rente',
        completionDetailsLoanAmount: 'Lånebeløp inkl. gebyr',
        completionDetailsLoanPeriod: 'Nedbetalingstid',
        completionDetailsMonthlyCost: 'Månedsbeløp inkl. gebyr',
        completionDetailsPledgeFee: 'Tinglysningsgebyr',
        completionDetailsStartupFee: 'Etableringsgebyr',
        completionDetailsTermFee: 'Termingebyr',
        completionDetailsTotalCost: 'Totalbeløp',
        completionDetailsVehicleInfoManufacturer: 'Merke',
        completionDetailsVehicleInfoModel: 'Modell',
        completionDetailsVehicleInfoYear: 'År',
        completionDetailsVehicleInfoRegNo: 'Reg.nr',
        completionDetailsVehicleInfoVehiclePrice: 'Kjøpesum',
        completionDetailsP1:
            'Tilbudet er gyldig i 30 dager. Lånedokumentene må signeres av deg og ev. medlåntaker før du kan overta kjøretøyet!',
        completionDetailsP2:
            'Kjøpesum i kjøpekontrakt må være lik kjøpesum i gjeldsbrevet. Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no hvis noe må endres.',
        completionDetailsP3:
            'Klar for å signere? Vi har kanskje et par raske spørsmål på neste side. Så kan du gå rett til signering.',
        completionDetailsP3CoApplicant:
            'Klar for å signere? Vi trenger oppdatert kontaktinformasjon og har kanskje et par raske spørsmål på neste side. Så kan du gå rett til signering.',
        completionDetailsLabelInsurance: 'Ønsker du betalingsforsikring?',
        completionDetailsContactInfoTitle: 'Din kontaktinformasjon',

        /* Completion: Signing */
        completionSigningTitle: 'Signering av dokumenter',
        completionSigningText: 'Du har to dokumenter du må signere med BankID for å fullføre lånesøknaden.',
        completionSigningDebtDocText: 'Du skal nå signere gjeldsbrevet med BankID.',
        completionSigningDebtDocSignedText: 'Du har signert gjeldsbrevet.',
        completionSigningMortgageDocText: 'Du skal nå signere pantsettelsesgrunnlaget med BankID.',
        completionSigningExternalServiceError:
            'Det oppstod problemer hos en ekstern tjeneste. Vennligst prøv igjen senere.',
        completionSigningInfoBox:
            'Har du spørsmål vedrørende signeringen? Vi hjelper deg på telefon 915 03 850 eller e-post kundesenter@eika.no',
        completionSigningButtonText: 'Gå til BankID signering',
        /* Completion: Receipt */
        completionReceiptTitle: 'Takk!',
        completionReceiptCaseNo: 'Ditt saksnummer:',
        completionReceiptCompleteP1: 'Alle lånedokumenter er signert og du kan gjennomføre kjøpet.',
        completionReceiptCompleteP2:
            'Ta kontakt med oss på soknad@eika.no eller 915 06 270 når du har kjøpekontrakten så hjelper vi deg videre.',
        completionReceiptIncompleteP1:
            'Du har signert lånedokumentene. Nå mangler vi bare signatur fra din medlåntaker. Når begge har signert kan dere gjennomføre kjøpet.',
        completionReceiptIncompleteP2: 'Ta kontakt med oss på soknad@eika.no eller 915 06 270 hvis du lurer på noe.',

        /* Form */
        formChooseValue: 'Velg et alternativ',
        formErrorMessage: 'Vennligst kontroller skjemaet',
        formErrorLoanAmountMessage: 'Lånebehovet må være mellom',
        formErrorUpdateOngoingMessage:
            'Ups! Her gikk noe galt ved innsending, vennligst prøv igjen eller ta kontakt med banken om problemet vedvarer.',

        /* KYC */
        kycInfoTitle: 'Kundeerklæring og antihvitvask',
        kycInfoQuestions:
            'Nedenfor kommer lovpålagte spørsmål som vi er nødt til å stille alle nye kunder og når du tar opp nye lån.',
        kycInfoNoQuestions: 'Det var alt. Vi trenger ikke flere opplysninger fra deg',

        /* Consent */
        consentTitle: 'Samtykker',
        consentDescription: '',
        consentModalButtonOpenText: 'Hva betyr dette?',
        consentModalButtonCloseText: 'Ok, jeg forstår',

        /* Receipt: Approved */
        receiptApprovedTitle: 'Lånet er innvilget',
        receiptApprovedP1: 'Ditt saksnummer:',
        receiptApprovedP2: 'Tilbudet varer i 30 dager. Hvis ikke kan vi ikke utbetale lånet. ',
        receiptApprovedP3: 'Du og ev. medlåntaker må signere lånedokumentene før du kan overta kjøretøyet.',
        receiptApprovedP4:
            'Kjøpesum i kjøpekontrakt må være lik kjøpesum i gjeldsbrevet. Ta kontakt med oss hvis det ikke stemmer.',
        receiptApprovedP5:
            'Hvis vi trenger mer informasjon fra deg så får du spørsmål på neste side. Hvis ikke går du rett til signering.',
        receiptApprovedInfoBox:
            'Lurer du på noe? Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',
        receiptApprovedInfoBoxTitle: 'Forsikre kjøretøyet',
        receiptApprovedInfoBoxLinkText:
            'Sjekk hvilken forsikring som passer best for deg. Hos oss får du 60% startbonus.',

        /* Receipt: Approved - Loan Commitment */
        receiptApprovedLoanCommitmentTitle: 'Lånebeviset er innvilget',
        receiptApprovedLoanCommitmentP1: 'Ditt saksnummer:',
        receiptApprovedLoanCommitmentP2A: 'Du har fått innvilget et lånebevis på',
        receiptApprovedLoanCommitmentP2B: '. Det er gyldig i 3 måneder.',
        receiptApprovedLoanCommitmentP3:
            'Når du har funnet kjøretøyet du vil kjøpe, så vil vi trenge følgende informasjon:',
        receiptApprovedLoanCommitmentList1: 'Registreringsnummer',
        receiptApprovedLoanCommitmentList2: 'Nøyaktig kjøpesum',
        receiptApprovedLoanCommitmentList3: 'Kilometerstand',
        receiptApprovedLoanCommitmentList4:
            'Ved nykjøp fra merkeforhandler er det tilstrekkelig med kopi av kjøpekontrakt.',
        receiptApprovedLoanCommitmentList5: 'Husk at lånepapirene må signeres før du kan kjøpe og overta kjøretøyet.',
        receiptApprovedLoanCommitmentDocumentButtonText: 'Ditt lånebevis',
        receiptApprovedLoanCommitmentInfoBox:
            'Lurer du på noe? Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',
        receiptApprovedLoanCommitmentWarning:
            'VIKTIG. Objektet må godkjennes og lånedokumentene MÅ være signert før du overtar kjøretøyet.',

        /* Receipt: Control */
        receiptControlTitle: 'Sendt til vurdering',
        receiptControlP1: 'Ditt saksnummer:',
        receiptControlP2: 'Vi må se litt nærmere på saken din. Kanskje vil vi be om litt mer informasjon også.',
        receiptControlP3: 'Vi håper å kunne gi deg rask tilbakemelding. Du vil da få en ny e-post av oss.',
        receiptControlButtonLink: '/',
        receiptControlButtonText: 'Avslutt',
        receiptControlInfoBox:
            'Lurer du på noe? Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',

        receiptOtherPersonTitle: 'Tusen takk!',
        receiptOtherPersonP1: 'Vi har fått all informasjon vi trenger fra deg.',
        receiptOtherPersonP2:
            'Nå venter vi på litt mer informasjon fra din medlåntaker før vi kan behandle ferdig søknaden.',
        receiptOtherPersonButtonLink: '/',
        receiptOtherPersonButtonText: 'Avslutt',
        receiptOtherPersonInfoBox:
            'Lurer du på noe? Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',

        receiptSblFailedTitle: 'Tusen takk!',
        receiptSblFailedP1: 'Vi har fått all informasjon vi trenger fra deg.',
        receiptSblFailedP2:
            'Vi må se litt nærmere på saken din, og vil gi deg beskjed når saken er klar for signering.',
        receiptSblFailedButtonLink: '/',
        receiptSblFailedButtonText: 'Avslutt',
        receiptSblFailedInfoBox:
            'Lurer du på noe? Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',

        /* Receipt: Control - Feedback */
        feedbackTitle:
            'Har du informasjon som kan hjelpe oss i å vurdere søknaden din? Gi oss gjerne tilbakemelding her:',
        feedbackLabel: 'Tilbakemelding',
        feedbackPlaceholder: 'Legg inn en tilbakemelding her',
        feedbackButton: 'Oppdater saken',
        feedbackResponse: 'Takk! Saken er nå oppdatert!',

        /* Receipt: Rejected */
        receiptRejectedTitle: 'Beklager, søknaden er avslått',
        receiptRejectedP1: 'Ditt saksnummer:',
        receiptRejectedP2:
            'Ved behandling av søknaden din har vi hentet informasjon fra kredittopplysningsbyrå og gjeldsregisteret, samt vurdert informasjonen mot våre retningslinjer. Basert på en helhetlig vurdering kan vi dessverre ikke tilby deg lån på nåværende tidspunkt.',
        receiptRejectedP3:
            'Har du tilleggsinformasjon eller andre opplysninger som kan endre vår vurdering? Ta gjerne kontakt med oss på soknad@eika.no. Du er velkommen å søke på nytt hvis din økonomiske situasjon endrer seg.',
        receiptRejectedButtonLink: '/',
        receiptRejectedButtonText: 'Avslutt',
        receiptRejectedInfoBox:
            'Lurer du på noe? Ta kontakt med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',
        summaryInfoBoxDeclinedFrozen:
            'Du har aktivert frivillig kredittsperre hos kredittopplysningsforetak. Da får ikke vi hentet noe informasjon på deg og du kan ikke søke om kredittkort eller lån. Hvis du fjerner sperren hos Dun & Bradstreet så kan du søke på nytt.',
        /* Common */
        defaultInfoBoxText:
            'Lurer du på noe? Ta gjerne en prat med oss på telefon 915 06 270 eller e-post soknad@eika.no. Vi hjelper deg gjerne!',

        /* Expand Privacy */
        expandPrivacyTitle: 'Personvern',
        expandPrivacyText1:
            'Denne finansieringstjenesten leveres av Eika Digitalbank AS som er ansvarlig for behandling av personopplysningene som oppgis og hentes inn. Vi trenger dine opplysninger for å kunne gi deg riktige betingelser og kunne inngå en avtale med deg.',
        expandPrivacyText2:
            'Vi lagrer opplysningene så lenge det kan oppstå et krav knyttet til finansieringstjenesten. Om du ikke får innvilget eller benytter deg av finansieringstjenesten lagrer vi opplysningene i 3 måneder etter at de er gitt til oss. Når du har fått innvilget en finansieringstjeneste hos oss kan vi bruke opplysningene om hvilke produkter du har for å tilpasse vår kommunikasjon til deg.',
        expandPrivacyText3: 'Spørsmål om personvern?',
        expandPrivacyText4:
            'Dersom du ønsker informasjon om dine rettigheter rundt blant annet sletting, innsyn, klage, og samtykke finner du det på vår personvernside.',
        expandPrivacyText5: 'Gå til personvernsiden',
        expandPrivacyText5Url: 'https://www2.eika.no/personvern-cookies',
        expandPrivacyText6: 'Vårt personvernombud hjelper deg gjerne. Send e-post til personvern.kredittbank@eika.no',

        /* Generic Error */
        genericErrorTitle: 'Vi beklager',
        genericErrorText1: 'Det har oppstått en feil i løsningen. Du kan dessverre ikke fullføre søknaden nå.',
        genericErrorText2: 'Vi jobber med å løse feilen og du kan gjøre et nytt forsøk om en stund.',
        genericErrorText3: 'Hvis det fortsatt ikke fungerer, ta kontakt med oss.',
        genericErrorLink: '',
        genericErrorLinkText: 'Gå tilbake til lånesiden',
        genericErrorInfoBox: '{defaultInfoBoxText}',

        /* External Service Error */
        serviceErrorTitle: 'Vi beklager',
        serviceErrorText1: 'Vi klarte ikke å kommunisere med en ekstern tjeneste.',
        serviceErrorText2:
            'Du kan prøve å laste siden på ny og prøve igjen. Hvis det fortsatt er feil, så må du dessverre vente en stund. Vi er på saken og prøver å løse feilen så fort som mulig.',
        serviceErrorLink: '',
        serviceErrorLinkText: 'Last siden på ny',
        serviceErrorInfoBox: '{defaultInfoBoxText}',

        /* SBL Tax period error */
        sblTaxPeriodErrorTitle: 'Vi beklager',
        sblTaxPeriodErrorText1:
            'Vi fikk ikke tilbake noe data på skatt og inntekt og har dermed ikke nok informasjon til å vurdere søknaden.',
        sblTaxPeriodErrorText2:
            'Hvis du mener dette er feil og har nok data fra siste skatteår, så ta kontakt med oss. Vi kan da kanskje få overført data fra deg manuelt og behandle saken manuelt. ',
        sblTaxPeriodErrorInfoBox: '{defaultInfoBoxText}',

        /* Price Lookup Error */
        priceLookupErrorTitle: 'Feil under prisoppslag',
        priceLookupErrorText1: 'Vi finner ikke bilen din i systemet vårt. Søk om lånebevis, så vil vi hjelpe deg.',
        priceLookupErrorLink: '',
        priceLookupErrorLinkText: 'Gå tilbake til lånesiden',
        priceLookupErrorInfoBox: '{defaultInfoBoxText}',

        /* Loan upgrade Error */
        upgradeLoanErrorTitle: 'Feil',
        upgradeLoanErrorText1: 'Gjelder det ny bil uten reg.nr.? Ta kontakt med oss på soknad@eika.no',
        upgradeLoanErrorLink: '#/',
        upgradeLoanErrorLinkText: 'Gå tilbake til lånesiden',
        upgradeLoanErrorInfoBox: '{defaultInfoBoxText}',

        /* Eurotax vehicle details search */
        eurotaxSearchButton: 'Hent kjøretøy',
        eurotaxSubmitButton: 'Send',
        eurotaxProductionYear: 'Produksjonsår',
        eurotaxOdometer: 'Kilometerstand',
        eurotaxOdometerPlaceholder: 'Fyll inn antall km',
        eurotaxManufacturer: 'Produsent',
        eurotaxModel: 'Bilmodell',
        eurotaxRegNumber: 'Registreringsnummer',
        eurotaxPrice: 'Kjøpesum',
        eurotaxPricePlaceholder: 'Fyll inn antall kr',
        eurotaxEquity: 'Egenkapital',
        eurotaxEquityPlaceholder: 'Fyll inn antall kr',
        eurotaxDuration: 'Nedbetalingstid',
        eurotaxDurationYear: 'år',
        eurotaxSelectDurationPlaceholder: 'Velg et alternativ',
        eurotaxImported: '(bruktimport)',
        eurotaxUnknown: 'Ukjent / ikke oppgitt',
        eurotaxDurationText:
            'Vi anbefaler å betale ned lånet så fort som mulig og på den tiden du tenker å beholde bilen. For elbil/billån kan bilens alder ikke overstige 14 år når lånet er nedbetalt. For kaskofritt lån må lånebehovet være maks 100 000 kr.',

        /* Eurotax vehicle details search Error */
        eurotaxSearchErrorTitle: 'Feil',
        eurotaxSearchErrorText1: 'Gjelder det ny bil uten reg.nr.? Ta kontakt med oss på soknad@eika.no',
        eurotaxSearchErrorLink: '#/',
        eurotaxSearchErrorLinkText: 'Gå tilbake til lånesiden',
        eurotaxSearchErrorInfoBox: '{defaultInfoBoxText}',
        eurotaxEmissionWarning:
            'Kjøretøyet er ikke en nullutslippsbil og dette finansieringsbeviset kan ikke benyttes. Ta kontakt med oss på soknad@eika.no så hjelper vi deg videre.',
        eurotaxPlateNotFoundWarning: 'Vi klarte ikke å finne kjøretøyet. Har du skrevet riktig?',

        eurotaxLoanAmountMessage1: 'Lånebehovet må være mellom ',
        eurotaxLoanAmountMessage2: ' kroner. Dersom kjøretøyet er dyrere ta kontakt med oss.',

        eurotaxLoanEquityAmountMessage1: 'Lånebeløpet må være mellom ',
        eurotaxLoanEquityAmountMessage2: ' kroner. Dersom kjøretøyet er dyrere ta kontakt med oss.',

        loanUpgradeSuccessTitle: 'Takk!',
        loanUpgradeSuccessText1: 'Ditt saksnummer: ',
        loanUpgradeSuccessText2: 'Tusen takk. Kjøretøyet er registrert. Du hører fra oss i løpet av 1-2 virkedager.',
        loanUpgradeSuccessText3: '',
        loanUpgradeSuccessLink: '#/',
        loanUpgradeSuccessLinkText: 'Avslutt',
        loanUpgradeSuccessInfoBox: '{defaultInfoBoxText}',

        /* Customer has D-Number */
        customerDNumberTitle: 'Beklager, du har ugyldig fødselsnummer',
        customerDNumberText: 'Du kan dessverre ikke søke om lån med D-nummer.',
        customerDNumberLink: '',
        customerDNumberLinkText: 'Tilbake til forsiden',
        customerDNumberInfoBox: '{defaultInfoBoxText}',

        /* Customer is a Minor */
        customerMinorTitle: 'Beklager, du er ikke gammel nok',
        customerMinorText: 'Du kan dessverre ikke søke om lån når du er under 18 år.',
        customerMinorLink: '',
        customerMinorLinkText: 'Tilbake til forsiden',
        customerMinorInfoBox: '{defaultInfoBoxText}',

        /* Customer is missing in Bisnode (AAA Soliditet) */
        customerMissingInBisnodeTitle: 'Beklager, vi finner ikke ditt fødselsnummer',
        customerMissingInBisnodeText:
            'Vi finner ikke ditt fødselsnummer i kredittsjekk. Dersom du nylig har fylt 18 år vil dette bli oppdatert snart, prøv igjen om noen dager.',
        customerMissingInBisnodeLink: '',
        customerMissingInBisnodeLinkText: 'Tilbake til forsiden',
        customerMissingInBisnodeInfoBox: '{defaultInfoBoxText}',

        /* Customer is missing address */
        customerMissingAddressTitle: 'Ikke norsk adresse i Folkeregisteret',
        customerMissingAddressText1:
            'Har du ikke registrert adresse eller har utenlandsk adresse? Da kan du dessverre ikke fortsette søknaden. Ta kontakt hvis du mener dette er feil.',
        customerMissingAddressLink: '',
        customerMissingAddressLinkText: 'Tilbake til forsiden',
        customerMissingAddressInfoBox: '{defaultInfoBoxText}',

        /* 404 Page not found */
        pageNotFoundTitle: 'Siden finnes ikke',
        pageNotFoundText1: 'Vi beklager så mye, men vi finner ikke siden du leter etter.',
        pageNotFoundText2: '',
        pageNotFoundText3: 'Vårt beste tips er å bruke menyen, håper at du finner det du leter etter der.',
        currencyInputPlaceholderKr: 'Fyll inn antall kr',
        currencyInputPlaceholderKm: 'Fyll inn antall km',
        trafficLightPre: 'Din betalingsevne er vurdert til',
        trafficLightGreen: 'grønn',
        trafficLightYellow: 'gul',
        trafficLightRed: 'rød',
        trafficLightModalTitle: 'Din betalingsevne',
        trafficLightModalP1:
            'Vi er pålagt å kartlegge din fremtidige betalingsevne for å forutse hvordan du vil kunne håndtere din gjeld dersom betingelsene for kreditten endrer seg.',
        trafficLightModalP2Green:
            'Vi vurderer din betalingsevne som god. Du antas å kunne håndtere en potensiell økning av renten tilknyttet din kreditt godt.',
        trafficLightModalP2Yellow:
            'Vi vurderer din betalingsevne som middels god. Du antas å kunne håndtere en potensiell økning av renten tilknyttet din kreditt med moderate tilpasninger i din økonomi.',
        trafficLightModalP2Red:
            'Vi vurderer din betalingsevne som lav. Du antas å ikke være i stand til å håndtere en potensiell økning av renten tilknyttet din kreditt med mindre du gjør større tilpasninger i din økonomi.',
        trafficLightModalClose: 'Lukk',

        loanDetailsInsurance: 'Ønsker du betalingsforsikring?',
        loanDetailsInsurancePriceP1: 'Supert at du ønsker forsikring!',
        loanDetailsInsurancePriceP2: 'Prisen som blir lagt til ditt månedsbeløp er:',
        loanDetailsInsurancePriceRate: '7.9',
        loanDetailsInsuranceTitle: 'Betalingsforsikring',
        loanDetailsInsuranceDescription:
            'Betalingsforsikring kan være veldig nyttig hvis uhellet skulle være ute og du sliter med å betale lånet. Forsikringen dekker da månedsbeløpet. Det koster kun 7,9 % av månedsbeløpet.',
        loanDetailsInsuranceInfoBoxP1: 'For å kjøpe forsikringen må du bekrefte at du:',
        loanDetailsInsuranceInfoBoxB1: 'Er fast ansatt i minimum 50 % stilling eller er selvstendig næringsdrivende.',
        loanDetailsInsuranceInfoBoxB2:
            'Har ikke vært sykmeldt i mer enn 30 dager sammenhengende siste 12 måneder og mottar ikke sykepenger, arbeidsavklaringspenger, dagpenger, uføretrygd eller liknende stønad eller erstatning.',
        loanDetailsInsuranceInfoBoxB3:
            'Har ikke mottatt personlig varsel om arbeidsledighet eller varsel om permittering er gitt, eller burde ha grunn til å regne med forestående ufrivillig tap av arbeid.',
        loanDetailsInsuranceTermsPre: 'Se fullstendig informasjon: ',
        loanDetailsInsuranceTermsText1: 'Forsikringsbeskrivelse (pdf), ',
        loanDetailsInsuranceTermsText2: 'Vilkår (pdf)',
        loanDetailsInsuranceTermsLink1:
            '-/media/fellesfiler/kredittkort/Amtrust/NO_AIU IPID Betalingsforsikring ln og kort 2_0',
        loanDetailsInsuranceTermsLink2: '-/media/fellesfiler/ekb/betalingsforsikring_informasjon',
        loanDetailsInsuranceConfirm: 'Jeg bekrefter at jeg har lest forkjøpsinformasjonen og kan kjøpe forsikringen',
        loanDetailsConsentTooltipText: 'Hva betyr dette?',
        loanDetailsConsentModalButtonText: 'Ok, jeg forstår',
        loanDetailsInsuranceConfirmErrorText:
            'Du må bekrefte at du har lest forkjøpsinformasjonen og kan kjøpe forsikringen',
    },
    form: {
        requestedLoanPeriodInMonths: {
            label: 'Nedbetalingstid',
            selected: '48',
            values: [
                {
                    text: '1 år',
                    value: '12',
                },
                {
                    text: '2 år',
                    value: '24',
                },
                {
                    text: '3 år',
                    value: '36',
                },
                {
                    text: '4 år',
                    value: '48',
                },
                {
                    text: '5 år',
                    value: '60',
                },
                {
                    text: '6 år',
                    value: '72',
                },
                {
                    text: '7 år',
                    value: '84',
                },
                {
                    text: '8 år',
                    value: '96',
                },
                {
                    text: '9 år',
                    value: '108',
                },
                {
                    text: '10 år',
                    value: '120',
                },
            ],
        },
        livingConditionCode: {
            label: 'Boforhold',
            selected: '',
            values: [
                {
                    text: 'Velg',
                    value: '',
                },
                {
                    text: 'Eier bolig',
                    value: 'OWNS_HOUSING',
                },
                {
                    text: 'Leier bolig',
                    value: 'RENTS_HOUSING',
                },
                {
                    text: 'Bor hos foreldre',
                    value: 'LIVING_WITH_PARENTS',
                },
            ],
        },
        rentalFees: {
            label: 'Leiekostnader per måned',
            tooltip: '',
        },
        employmentConditionCode: {
            label: 'Arbeidsforhold',
            selected: '',
            values: [
                {
                    text: 'Velg',
                    value: '',
                },
                {
                    text: 'Fast ansatt',
                    value: 'FULL_TIME_EMPLOYEE',
                },
                {
                    text: 'Midlertidig/vikar',
                    value: 'TEMPORARY_EMPLOYEE',
                },
                {
                    text: 'Selvstendig',
                    value: 'SELF_EMPLOYED',
                },
                {
                    text: 'Student',
                    value: 'STUDENT',
                },
                {
                    text: 'Pensjonist',
                    value: 'RETIRED',
                },
                {
                    text: 'Arbeidsledig',
                    value: 'UNEMPLOYED',
                },
                {
                    text: 'Arbeidsavklaringspenger',
                    value: 'UNEMPLOYMENT_BENEFITS',
                },
                {
                    text: 'Ufør',
                    value: 'DISABLED',
                },
                {
                    text: 'Annet',
                    value: 'OTHER',
                },
            ],
        },
    },
};

export default sitecoreSimulationData;
